import React from 'react';
import PropTypes from 'prop-types';
import { Hero } from './Hero';
import { Split } from './Split';
import { Feature } from './Feature';

const components = {
  hero: Hero,
  split: Split,
  feature: Feature,
};

const contentMap = {
  WealthComHeader: { Component: components.hero },
  WealthComHowItWorks: { Component: components.split },
  WealthComOffering: { Component: components.split },
  WealthComSimplicity: { Component: components.split, props: { flipped: true } },
  WealthComStateSpecificDocs: { Component: components.feature },
  WealthComOngoingUpdates: { Component: components.feature },
  WealthComTrustPackage: { Component: components.feature },
  WealthComWillPackage: { Component: components.feature },
};

const getComponent = (id) => {
  const result = { Component: Split, props: {} };

  const content = contentMap[id];
  if (content) {
    result.Component = content.Component;
    result.props = { ...content.props };
  }

  return result;
};

export const StructuredContentItem = ({ structuredContentResource }) => {
  const { Component, props } = getComponent(structuredContentResource.id());

  return (
    <Component
      key={structuredContentResource.id()}
      {...props}
      structuredContentResource={structuredContentResource}
    />
  );
};

StructuredContentItem.propTypes = {
  structuredContentResource: PropTypes.object.isRequired,
};
